// extracted by mini-css-extract-plugin
export default {"lists":"BurgerIngredientGroup_lists__+QG2i"};